"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _vuex = require("vuex");
var _default = exports.default = {
  name: 'Exception404',
  computed: {
    ...(0, _vuex.mapGetters)(['firstMenuPath'])
  },
  methods: {
    toHome() {
      this.$router.replace(this.firstMenuPath);
    }
  }
};